export default __webpack_public_path__ + "static/media/escalation-yellow.4f0464a2.svg";